/**
 * Sales Invoice Credited By Formatter.
 */
window.salesInvoiceCreditedByFormatter = function(value, row) {
    let html = '';
    if (can('admin.sales.invoices.show') && row.credited_by) {
        html += '<a href="/admin/sales/invoices/show/'+row.credited_by_id+'">';
        html += row.credited_by;
        html += '</a>';
    } else if (can('tuijncode.invoices') && row.credited_by) {
        html += '<a href="/tuijncode/invoices/show/'+row.credited_by_id+'">';
        html += row.credited_by;
        html += '</a>';
    }
    return html;
}
